/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<circle pid="0" cx="96" cy="256" r="80"/><circle pid="1" cx="416" cy="96" r="80"/><circle pid="2" cx="416" cy="416" r="80"/><path pid="3" d="M105.8 275.7L425.8 115.7 406.2 76.3 86.2 236.3z"/><path pid="4" d="M86.2 275.7L406.2 435.7 425.8 396.3 105.8 236.3z"/>'
  }
})
